<script lang="ts">
  import { onDestroy, onMount } from 'svelte';

  export let time = 0;

  const interval = 1000; // ms
  let stopInterval = () => {};

  // https://github.com/unimonkiez/self-adjusting-interval
  function setSelfAdjustingInterval(cb: (ticks: number) => void, interval: number) {
    let expected = Date.now() + interval;
    let stop = false;
    let timerId: number;

    const tick = () => {
      if (stop) {
        return;
      }

      const delta = Date.now() - expected;
      const ticks = Math.max(1, 1 + Math.round(delta / interval));
      cb(ticks);

      const addToExpected = interval * ticks;
      expected += addToExpected;

      timerId = window.setTimeout(tick, addToExpected - delta);
    };

    timerId = window.setTimeout(tick, interval);

    const stopInterval = () => {
      clearTimeout(timerId);
      stop = true;
    };

    return stopInterval;
  }

  const start = () => {
    stopInterval = setSelfAdjustingInterval((ticks) => {
      time = time - ticks * interval;
    }, interval);
  };

  onMount(start);

  onDestroy(() => {
    stopInterval();
  });
</script>
